import { useState } from 'react';
import axios from 'axios';

const API = '/api';

function Register({ onLogin, onGoLogin }) {
  const [inviteCode, setInviteCode] = useState('');
  const [inviteVerified, setInviteVerified] = useState(false);
  const [inviteError, setInviteError] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');

  const handleInviteSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/auth/verify-invite`, { inviteCode });
      setInviteVerified(true);
      setInviteError('');
    } catch (err) {
      setInviteError(err.response?.data?.error || 'Invalid invite code');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError('Passwords do not match');
    if (password.length < 8) return setError('Password must be at least 8 characters');
    try {
      const res = await axios.post(`${API}/auth/register`, { email, password, inviteCode });
      localStorage.setItem('token', res.data.token);
      onLogin(res.data.token);
    } catch (err) {
      setError(err.response?.data?.error || 'Registration failed');
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Mono:wght@300;400;500&family=DM+Sans:wght@300;400;500&display=swap');
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'DM Sans', sans-serif; background: #f7f6f3; }
        .auth-wrap { min-height: 100vh; display: flex; align-items: center; justify-content: center; }
        .auth-card { background: #fff; border: 1px solid #e8e6e1; border-radius: 6px; padding: 40px; width: 380px; }
        .auth-logo { font-family: 'DM Mono', monospace; font-size: 20px; font-weight: 500; margin-bottom: 8px; }
        .auth-logo span { color: #880015; }
        .auth-subtitle { font-family: 'DM Mono', monospace; font-size: 11px; color: #9b9690; letter-spacing: 0.5px; margin-bottom: 32px; }
        .auth-label { font-size: 11px; font-family: 'DM Mono', monospace; color: #9b9690; letter-spacing: 0.5px; text-transform: uppercase; display: block; margin-bottom: 5px; }
        .auth-input { width: 100%; padding: 8px 10px; border: 1px solid #e8e6e1; border-radius: 4px; background: #f7f6f3; font-family: 'DM Sans', sans-serif; font-size: 13px; color: #1a1917; outline: none; transition: border-color 0.15s; }
        .auth-input:focus { border-color: #880015; background: white; }
        .auth-field { margin-bottom: 14px; }
        .auth-btn { width: 100%; padding: 9px; background: #1a1917; color: white; border: none; border-radius: 4px; cursor: pointer; font-family: 'DM Sans', sans-serif; font-size: 13px; font-weight: 500; margin-top: 6px; transition: opacity 0.15s; }
        .auth-btn:hover { opacity: 0.85; }
        .auth-error { font-family: 'DM Mono', monospace; font-size: 11px; color: #dc2626; margin-bottom: 12px; }
        .auth-success { font-family: 'DM Mono', monospace; font-size: 11px; color: #16a34a; margin-bottom: 12px; }
        .auth-switch { margin-top: 20px; text-align: center; font-family: 'DM Mono', monospace; font-size: 11px; color: #9b9690; border-top: 1px solid #e8e6e1; padding-top: 20px; }
        .auth-switch span { color: #880015; cursor: pointer; }
        .auth-switch span:hover { text-decoration: underline; }
        .auth-reveal { overflow: hidden; transition: max-height 0.3s ease, opacity 0.3s ease; }
        .auth-reveal.hidden { max-height: 0; opacity: 0; pointer-events: none; }
        .auth-reveal.visible { max-height: 400px; opacity: 1; }
      `}</style>
      <div className="auth-wrap">
        <div className="auth-card">
          <div className="auth-logo">fin<span>trak</span></div>
          <div className="auth-subtitle">create an account</div>

          {/* Invite code field - always visible */}
          <div className="auth-field">
            <label className="auth-label">Invite Code</label>
            <div style={{ display: 'flex', gap: '8px' }}>
              <input
                className="auth-input"
                type="password"
                value={inviteCode}
                onChange={e => { setInviteCode(e.target.value); setInviteVerified(false); setInviteError(''); }}
                placeholder="enter invite code"
                autoFocus
              />
              <button
                type="button"
                onClick={handleInviteSubmit}
                style={{ padding: '8px 14px', background: inviteVerified ? '#16a34a' : '#1a1917', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontFamily: 'DM Mono, monospace', fontSize: '12px', whiteSpace: 'nowrap', transition: 'background 0.2s' }}
              >
                {inviteVerified ? '✓' : 'verify'}
              </button>
            </div>
            {inviteError && <div className="auth-error" style={{ marginTop: '6px', marginBottom: 0 }}>{inviteError}</div>}
            {inviteVerified && <div className="auth-success" style={{ marginTop: '6px', marginBottom: 0 }}>✓ invite code accepted</div>}
          </div>

          {/* Rest of form - revealed after invite verified */}
          <div className={`auth-reveal ${inviteVerified ? 'visible' : 'hidden'}`}>
            <form onSubmit={handleSubmit}>
              <div className="auth-field">
                <label className="auth-label">Email</label>
                <input className="auth-input" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
              </div>
              <div className="auth-field">
                <label className="auth-label">Password</label>
                <input className="auth-input" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
              </div>
              <div className="auth-field">
                <label className="auth-label">Confirm Password</label>
                <input className="auth-input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required />
              </div>
              {error && <div className="auth-error">{error}</div>}
              <button type="submit" className="auth-btn">Create account</button>
            </form>
          </div>

          <div className="auth-switch">
            already have an account? <span onClick={onGoLogin}>sign in</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Register;